import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  HStack,
  Icon,
  Image,
  SkeletonText,
  Text,
} from "@chakra-ui/react";
import { RiFile2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "../../../assets/colorLogo.png";
import { BiCalendarEvent } from "react-icons/bi";
import { BsPeople } from "react-icons/bs";
import { GoDeviceCameraVideo } from "react-icons/go";
import { MdOutlineAssessment } from "react-icons/md";
import { PiExam } from "react-icons/pi";
import { TbBasketQuestion } from "react-icons/tb";
import { AiOutlineGroup } from "react-icons/ai";
import { FaRegFileAlt } from "react-icons/fa";
import { CiSquareQuestion } from "react-icons/ci";
import { LuDollarSign } from "react-icons/lu";
import { CiHashtag } from "react-icons/ci";
const TeacherSidenavbar = () => {
  const isLoading = useSelector((state) => state.user.isLoading);

  let navTabs = [
    {
      mainLabel: "إدارة الطلاب",
      icon: <BsPeople size={24} />,
      children: [
        {
          label: "الطلاب",
          link: "/dashboard/students",
          icon: <BsPeople size={24} />,
        },
        {
          label: "المجموعات",
          link: "/dashboard/groups",
          icon: <AiOutlineGroup size={24} />,
        },
      ],
    },
    {
      mainLabel: "المحتوى التعليمي",
      icon: <FaRegFileAlt size={24} />,
      children: [
        {
          label: "المحتوى",
          link: "/dashboard/lessons",
          icon: <FaRegFileAlt size={24} />,
        },
        {
          label: "الأقسام",
          link: "/dashboard/sections",
          icon: <FaRegFileAlt size={24} />,
        },
        {
          label: "الفصول",
          link: "/dashboard/chapters",
          icon: <FaRegFileAlt size={24} />,
        },
        {
          label: "الحصص",
          link: "/dashboard/lectures",
          icon: <BiCalendarEvent size={24} />,
        },
        {
          label: "الفيديوهات",
          link: "/dashboard/videos",
          icon: <GoDeviceCameraVideo size={24} />,
        },
        {
          label: "فيديوهات مباشرة",
          link: "/dashboard/live-videos",
          icon: <GoDeviceCameraVideo size={24} />,
        },
        {
          label: "العلامات",
          link: "/dashboard/tags",
          icon: <CiHashtag size={24} />,
        },
      ],
    },
    {
      mainLabel: "الامتحانات والواجبات",
      icon: <PiExam size={24} />,
      children: [
        {
          label: "الامتحانات",
          link: "/dashboard/exams",
          icon: <PiExam size={24} />,
        },
        {
          label: "الواجبات",
          link: "/dashboard/homework",
          icon: <PiExam size={24} />,
        },
        {
          label: "بنك الاسئلة",
          link: "/dashboard/questions-bank",
          icon: <TbBasketQuestion size={24} />,
        },
      ],
    },
    {
      mainLabel: "طلبات الطلاب",
      icon: <CiSquareQuestion size={24} />,
      children: [
        {
          label: "طلبات الاختبار",
          link: "/dashboard/exam-redo-requests",
          icon: <CiSquareQuestion size={24} />,
        },
        {
          label: "طلبات المشاهدة",
          link: "/dashboard/videos-more-view-requests",
          icon: <CiSquareQuestion size={24} />,
        },
      ],
    },
    {
      mainLabel: "الدفع والحضور",
      icon: <LuDollarSign size={24} />,
      children: [
        {
          label: "الحضور والدفع وتعويضات الحصص",
          link: "/dashboard/payments",
          icon: <LuDollarSign size={24} />,
        },
      ],
    },
    {
      mainLabel: "التقارير",
      icon: <MdOutlineAssessment size={24} />,
      children: [
        {
          label: "تقرير المجموعات",
          link: "/dashboard/groups-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "الحضور",
          link: "/dashboard/attendence-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "غياب الامتحانات",
          link: "/dashboard/exam-attendence-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "حضور الامتحانات",
          link: "/dashboard/exam-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "غياب الواجبات",
          link: "/dashboard/homework-absent-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "حضور الواجبات",
          link: "/dashboard/homework-attendence-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير مشاهدات الفيديوهات",
          link: "/dashboard/videos-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير طباعة الاسئلة",
          link: "/dashboard/print-all-questions",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير عدم الدفع",
          link: "/dashboard/unpaid-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير مراجعة الواجبات",
          link: "/dashboard/uncomment-homework-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير الدفع",
          link: "/dashboard/paid-report",
          icon: <RiFile2Fill size={24} />,
        },
      ],
    },
  ];
  return (
    <Flex
      w={{ base: "10%", lg: "20%" }}
      p="0"
      h="100vh"
      flexDirection={"column"}
      zIndex="100"
      position="fixed"
      bg="#f5f5f5"
      borderLeft="1px solid #45424226"
      alignItems={{ base: "center", lg: "flex-start" }}
      className="scroll"
    >
      <Image
        alignSelf="center"
        my="20px"
        w="50%"
        loading="lazy"
        src={Logo}
        alt="Enough"
        onClick={() => window.location.replace("/")}
      />

      {isLoading ? (
        <HStack w="100%" bg="transparent" h="100%">
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={7}
            spacing="20"
          />
        </HStack>
      ) : (
        navTabs?.map((data, index) => {
          return data?.mainLabel ? (
            <Accordion allowMultiple w="100%" py={{ base: "0", lg: "15px" }}>
              <AccordionItem border={0} w="100%">
                <h2 style={{ border: 0 }}>
                  <AccordionButton
                    justifyContent="space-between"
                    outline={0}
                    _active={{
                      outline: "0",
                    }}
                    _focus={{
                      outline: "0",
                    }}
                  >
                    <Box
                      textAlign="left"
                      display="flex"
                      alignItems="center"
                      gap={3}
                    >
                      {data?.icon}{" "}
                      <Text
                        style={{ fontSize: "18px", fontWeight: "500" }}
                        display={{ base: "none", lg: "block" }}
                      >
                        {data?.mainLabel}
                      </Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel p={0} pb={4}>
                  {data?.children?.map((val, childIndex) => (
                    <Link
                      to={val.link}
                      key={`${index}-${childIndex}`}
                      style={{ width: "90%" }}
                    >
                      <Flex
                        w="100%"
                        color="black"
                        alignItems="center"
                        justifyContent={{ base: "center", lg: "flex-start" }}
                        mt="10px"
                        p={{ base: "0", lg: "25px" }}
                        cursor="pointer"
                        h={{ base: "60px", lg: "" }}
                        bg={
                          window.location.pathname == val.link
                            ? "#e4e4e4"
                            : "transparent"
                        }
                        borderRadius="15px"
                        fontWeight={
                          window.location.pathname == val.link ? "600" : "400"
                        }
                        _hover={{
                          bg: "#e4e4e4",
                          fontWeight: "600",
                        }}
                      >
                        {val?.icon}
                        <Text
                          fontSize="18px"
                          mx="20px"
                          mt="2px"
                          display={{ base: "none", lg: "block" }}
                          color="main_1"
                        >
                          {val.label}
                        </Text>
                      </Flex>
                    </Link>
                  ))}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          ) : (
            <Link to={data.link} key={index} style={{ width: "90%" }}>
              <Flex
                w="100%"
                color="black"
                alignItems="center"
                justifyContent={{ base: "center", lg: "flex-start" }}
                mt="10px"
                p={{ base: "0", lg: "25px" }}
                cursor={"pointer"}
                h={{ base: "60px", lg: "" }}
                bg={
                  window.location.pathname == data.link
                    ? "#e4e4e4"
                    : "transparent"
                }
                borderRadius="15px"
                fontWeight={
                  window.location.pathname == data.link ? "600" : "500"
                }
                _hover={{
                  bg: "#e4e4e4",
                  fontWeight: "600",
                }}
              >
                {data?.icon}
                <Text
                  fontSize="18px"
                  mx="20px"
                  mt="2px"
                  display={{ base: "none", lg: "block" }}
                  color="main_1"
                >
                  {data.label}
                </Text>
              </Flex>
            </Link>
          );
        })
      )}
    </Flex>
  );
};

export default TeacherSidenavbar;
